<template>

<div class="bg-box mx-4 flex flex-row rounded-md pb-2 mb-2">
    
    <div class=" w-1/3 flex flex-col">
    
        <div class="h-auto py-1 flex flex-row justify-center items-center">
            <span class="text-aux text-2xl -ml-2">Total</span>
        </div>

        <div class="flex-1 overflow-hidden relative flex flex-col justify-center items-center">
            <chartSalesDonnut :chartOptions="summary.total" />
            <div class="absolute h-56 w-56 rounded-full flex flex-col justify-between items-center py-12">
                
                <span class="text-success-30 text-xl">{{summary.total.orders}} <ShopIcon class="text-success" /></span>
                <span class="text-white text-2xl">{{summary.total.current_amount | numberFormat(2)}}€</span>
                <span class="text-success-30 text-xl">{{summary.total.percent}}%</span>
            </div>
        </div>
    
    
    </div>

    <div class=" w-1/3 flex flex-col">
    
        <div class="h-auto py-1 flex flex-row justify-center items-center">
            <span class="text-aux text-2xl -ml-2">Online</span>
        </div>

        <div class="flex-1 overflow-hidden relative flex flex-col justify-center items-center">
            <chartSalesDonnut :chartOptions="summary.online" />
            <div class="absolute h-56 w-56 rounded-full flex flex-col justify-between items-center py-12">
                
                <span class="text-success-30 text-xl">{{summary.online.orders}} <ShopIcon class="text-success" /></span>
                <span class="text-white text-2xl">{{summary.online.current_amount | numberFormat(2)}}€</span>
                <span class="text-success-30 text-xl">{{summary.online.percent}}%</span>
            </div>
        </div>
    
    
    </div>

    <div class=" w-1/3 flex flex-col">
    
        <div class="h-auto py-1 flex flex-row justify-center items-center">
            <span class="text-aux text-2xl -ml-2">Tiendas</span>
        </div>

        <div class="flex-1 overflow-hidden relative flex flex-col justify-center items-center">
            <chartSalesDonnut :chartOptions="summary.shops" />
            <div class="absolute h-56 w-56 rounded-full flex flex-col justify-between items-center py-12">
                
                <span class="text-success-30 text-xl">{{summary.shops.orders}} <ShopIcon class="text-success" /></span>
                <span class="text-white text-2xl">{{summary.shops.current_amount | numberFormat(2)}}€</span>
                <span class="text-success-30 text-xl">{{summary.shops.percent}}%</span>
            </div>
        </div>
    
    
    </div>
</div>
</template>

<script>

import chartSalesDonnut from '@/components/chartSalesDonnut.vue'
import ShopIcon from '@/components/icons/ShopIcon.vue'

    export default {
        name: 'salesDonnutsCharts',

        props: {
            summary: {
                type: Object,
                required: true
            }
        },

        components: {
            chartSalesDonnut,
            ShopIcon
        }
    }
</script>

<style>
.heightChart {
    height: 18rem;
}
</style>